import React, { useState, useEffect } from "react";
import { RequestCookieAccess } from "./RequestCookieAccess";

export const CookiesGateKeeper = (props: { children: React.ReactNode }) => {
	const [probingForCookie, setProbingForCookie] = useState(true);
	const [hasCookieAccess, setHasCookieAcess] = useState(false);

	useEffect(() => {
		const browserSupportsStorageAccessAPI =
			typeof document.hasStorageAccess === "function" &&
			typeof document.requestStorageAccess === "function";

		if (!browserSupportsStorageAccessAPI) {
			setProbingForCookie(false);
			setHasCookieAcess(true);
		}

		if (browserSupportsStorageAccessAPI) {
			const hasStorage: Promise<boolean> = document.hasStorageAccess();
			hasStorage.then(
				(access: boolean) => {
					setProbingForCookie(false);
					setHasCookieAcess(access);
					//console.log("Got access: " + access);
				},
				_ => {
					setProbingForCookie(false);
					//console.log("no access");
				}
			);
		}
	}, []);

	return probingForCookie ? null : !hasCookieAccess ? (
		<RequestCookieAccess callback={setHasCookieAcess} />
	) : (
		<>{props.children}</>
	);
};
